import React, { useState, useEffect } from "react";
import "./StudentReviews.css";

import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { reviews } from '../../data/siteData';

// Helper function to render stars
const renderStars = (rating) => {
  return "⭐".repeat(rating) + "☆".repeat(5 - rating);
};

export default function StudentReviews() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % reviews.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const next = () => setCurrent((prev) => (prev + 1) % reviews.length);
  const prev = () => setCurrent((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));

  return (
    <section className="reviews-section">
      <div className="reviews-title">
        <h2>Student <span>Reviews</span></h2>
        <p>What our students say about their learning journey.</p>
      </div>

      <div className="review-slider">
        <button className="review-arrow left" onClick={prev}>
          <LeftOutlined />
        </button>

        <div className="review-card">
          {/* LEFT: Image */}
          <div className="review-img">
            <img src={reviews[current].photo} alt={reviews[current].name} />
          </div>

          {/* RIGHT: Content */}
          <div className="review-content">
            <h3>{reviews[current].name}</h3>
            <h5>{reviews[current].role}</h5>
            <p>{reviews[current].review}</p>
            <div className="stars">{renderStars(reviews[current].rating)}</div>
          </div>
        </div>

        <button className="review-arrow right" onClick={next}>
          <RightOutlined />
        </button>
      </div>

      <div className="review-dots">
        {reviews.map((_, i) => (
          <span
            key={i}
            className={current === i ? "active" : ""}
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>
    </section>
  );
}